module.exports = __webpack_public_path__ + "node_modules/icheck/skins/square/green@2x.png?1a0de24f";